import React, { useCallback, useEffect, useState } from 'react';
import { Paper, Typography, Box, FormControl, InputLabel, Select, MenuItem, Button, DialogContent, TextField, Grid, FormControlLabel, Divider, Chip } from '@mui/material';
import jwtAuthAxios from 'app/services/auth/jwtAuth';
import CheckBoxOutlineBlankOutlinedIcon from '@mui/icons-material/CheckBoxOutlineBlankOutlined';
import useSwalWrapper from '@jumbo/vendors/sweetalert2/hooks';
import { Table, TableContainer, TableHead, TableBody, TableCell, TableRow, Dialog } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import { Add, AddBox, CheckBox, CheckBoxTwoTone, Delete, Edit, Square } from '@mui/icons-material';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Div from '@jumbo/shared/Div';
import { LoadingButton } from '@mui/lab';
import TableSkeleton from 'app/shared/widgets/TableSkeleton';
import useJumboAuth from '@jumbo/hooks/useJumboAuth';
import PropTypes from 'prop-types';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import JumboCardQuick from '@jumbo/components/JumboCardQuick';
// function createData(name, calories, fat, carbs, protein, price) {
//   return {
//     name,
//     calories,
//     fat,
//     carbs,
//     protein,
//     price,
//     history: [
//       {
//         date: '2020-01-05',
//         customerId: '11091700',
//         amount: 3,
//       },
//       {
//         date: '2020-01-02',
//         customerId: 'Anonymous',
//         amount: 1,
//       },
//     ],
//   };
// }

function Row(props) {
  const { row, handleSynonumParams } = props;
  const [open, setOpen] = React.useState(false);
  const [ParamsData, setParamsData] = React.useState([]);
  const [isedit, setIsedit] = React.useState({});
  const swal = useSwalWrapper()
  const {rights} = useJumboAuth()
  const ItemEditHandler = (e, index) => {
    // console.log(index);
    let tmpobj = ParamsData.splice(index, 1);
    // console.log(ParamsData[index]);
    setParamsData([...tmpobj, { ...ParamsData[index], FL_SYNONYM: e.target.value }])
    setIsedit({ ...isedit, [`a-${index}`]: false })
  }
  const formEditSubmitHandler = async(row,iid)=>{
    const {FL_SYNOID,FL_PNAME,FL_SYNONYM,FL_TYPE} = row
    // console.log(row,document.getElementById(`detail-a-${index}`).value,document.getElementById(`detail-b-${index}`).value);
    await jwtAuthAxios.post('master/addEditsynonymsmas',{FL_SYNOID,FL_PNAME,FL_SYNONYM:document.getElementById(`${iid}-a`).value,FL_TYPE:document.getElementById(`${iid}-b`).value}).then(res =>{
      swal.fire({
        icon:'success',
        text:res.data.message,
      })
      handleSynonumParams(row, setParamsData);
      // callback()
      }).catch(()=>{
        swal.fire({
          icon: 'error',
          text: 'Internal server Error',
        });
    })
}
  return (
    <React.Fragment>
      <TableRow sx={{ '& > *': { borderBottom: '0px' } }}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => { handleSynonumParams(row, setParamsData); setOpen(!open) }}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row"> {row.FL_PNAME} </TableCell>
        <TableCell align="right">{row.FL_TYPE}</TableCell>
        <TableCell align="right"></TableCell>
      </TableRow>
      <TableRow sx={{ background: (theme) => theme.palette.grey }}>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <JumboCardQuick>
                <Typography variant="H3" gutterBottom component="div">
                  {ParamsData[0]?.FL_PNAME}
                </Typography>
                <Table size="small" aria-label="purchases">
                  <TableHead>
                    <TableRow>
                      <TableCell>ID</TableCell>
                      <TableCell align="center">NAME</TableCell>
                      <TableCell align="center">TYPE</TableCell>
                      <TableCell align="right">Action</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {ParamsData.map((selectedParamType, index) => (
                      <TableRow key={selectedParamType.FL_SYNOID}>
                        <TableCell component="th" scope="row">
                          <Div>{selectedParamType.FL_SYNOID}</Div>
                        </TableCell>
                        <TableCell >
                          <TextField size='small'  fullWidth id={`detail-${selectedParamType.FL_SYNOID}-a`} defaultValue={selectedParamType.FL_SYNONYM} /></TableCell>
                        <TableCell align="right">
                        <TextField size='small'  fullWidth id={`detail-${selectedParamType.FL_SYNOID}-b`} defaultValue={selectedParamType.FL_TYPE} />
                          </TableCell>
                        <TableCell align="right">
                        {rights.edit ==1&& <LoadingButton variant='contained' size='small' onClick={()=>{formEditSubmitHandler(selectedParamType,`detail-${selectedParamType.FL_SYNOID}`)}} color='primary'>Save</LoadingButton>}
                           {rights.delete ==1&&<LoadingButton variant='contained' size='small' sx={{ ml: 2 }} onClick={()=>{jwtAuthAxios.get('master/deleteEditsynonymsmas/'+selectedParamType.FL_SYNOID).then(()=> {handleSynonumParams(row, setParamsData); setOpen(!open)})}} color='error'>Delete</LoadingButton>}
                        </TableCell>
                      </TableRow>
                    ))}
                    {rights.insert == 1 && <TableRow>
                        <TableCell component="th" scope="row">
                          <Div>-</Div>
                        </TableCell>
                        <TableCell>
                          <TextField size='small' fullWidth id={`detail-${ParamsData[0]?.FL_PNAME}-a`}  /></TableCell>
                        <TableCell align="right">
                        <TextField size='small' fullWidth id={`detail-${ParamsData[0]?.FL_PNAME}-b`}  />
                          </TableCell>
                        <TableCell align="right">
                          {rights.edit ==1&& <LoadingButton variant='contained' size='small' onClick={()=>{formEditSubmitHandler({FL_TYPE:ParamsData[0].FL_TYPE,FL_PNAME:ParamsData[0].FL_PNAME,FL_SYNOID:null},`detail-${ParamsData[0]?.FL_PNAME}`)}} color='primary'>Save</LoadingButton>}
                          {rights.delete ==1&& <LoadingButton variant='contained' size='small' sx={{ ml: 2 }} color='error'>Delete</LoadingButton>}
                        </TableCell>
                      </TableRow>}
                  </TableBody>
                </Table>
              </JumboCardQuick>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

Row.propTypes = {
  row: PropTypes.shape({
    calories: PropTypes.number.isRequired,
    carbs: PropTypes.number.isRequired,
    fat: PropTypes.number.isRequired,
    history: PropTypes.arrayOf(
      PropTypes.shape({
        amount: PropTypes.number.isRequired,
        customerId: PropTypes.string.isRequired,
        date: PropTypes.string.isRequired,
      }),
    ).isRequired,
    name: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
    protein: PropTypes.number.isRequired,
  }).isRequired,
};

// const rows = [
//   createData('Frozen yoghurt', 159, 6.0, 24, 4.0, 3.99),
//   createData('Ice cream sandwich', 237, 9.0, 37, 4.3, 4.99),
//   createData('Eclair', 262, 16.0, 24, 6.0, 3.79),
//   createData('Cupcake', 305, 3.7, 67, 4.3, 2.5),
//   createData('Gingerbread', 356, 16.0, 49, 3.9, 1.5),
// ];

function AllParametersTab() {
  const [selectedParamType, setSelectedParamType] = useState(null);
  const [data, setData] = useState([]);
  const [inventoryData, setInventoryData] = useState([]);
  const [paramTypes, setParamTypes] = useState([]);
  const [stdValue, setStdValue] = useState([]);
  const [openAddEditForm, setOpenAddEditForm] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const swal = useSwalWrapper();
  const fetchParamsData = async (FL_PNAME = null, FL_TYPE = null) => {
    setData([]);
    jwtAuthAxios.get(`master/synonymsmas`).then(data => {
      setParamTypes(data.data.rows)
    }).catch(e => {
      swal.fire({
        icon: 'error',
        text: 'Internal server error',
      });
    })
  };


  useEffect(() => {
    fetchParamsData();

  }, []);
  // useEffect(() => {
  //   console.log(paramTypes);

  // }, [paramTypes]);

  const handleParamChange = async (event) => {
    setSelectedParamType(event.target.value);
    fetchParamsData(event.target.value)
  };

  // const uniqueParamTypes = [...new Set(data.map((param) => param.FL_PARAM_TYPE))];

  const handleSynonumParams = async (row, callback) => {
    callback([])
    await jwtAuthAxios.get(`master/synonymsmas?FL_PNAME=${row.FL_PNAME}&FL_TYPE=${row.FL_TYPE}`).then(res => {
      callback(res.data.rows);
    }).catch(() => {
      swal.fire({
        icon: 'error',
        text: 'Internal server error',
      });
    })

  };
  const handleOpenAddEditForm = (item) => {
    setSelectedItem(item);
    setOpenAddEditForm(true);
  };

  const handleAddEditFormClose = () => {
    setSelectedItem(null);
    setOpenAddEditForm(false);
  };


  return (
    <>
      {/* <Paper elevation={3} style={{ padding: '20px' }}>
        <Grid container>
          <Grid item lg={6}>
            <Typography variant="h3" sx={{ mb: 3 }} gutterBottom>
              Globle Parameter Master
            </Typography>
          </Grid>
          <Grid item lg={6}>
            <Div sx={{ display: 'flex', gap: '20px', justifyContent: 'end' }}><FormControl style={{ minWidth: 200, marginBottom: 20 }}>
              {selectedParamType == null && <InputLabel sx={{ mb: 0 }}>{paramTypes.length ==0 ?'Loading Data':'Parameter Type'}</InputLabel>}
              <Select
                value={selectedParamType}
                onChange={handleParamChange}
                sx={{ mb: '-20px' }}
                disabled={paramTypes.length ==0}
              >
                {paramTypes.map(({ PARAMTYPE }) => (
                  <MenuItem key={PARAMTYPE} value={PARAMTYPE}>
                    {PARAMTYPE}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
              <LoadingButton
                variant="contained"
                color="primary"
                loading={paramTypes.length ==0 }
                size='large'
                onClick={() => handleOpenAddEditForm({})}
              >
                Add New
              </LoadingButton></Div>
          </Grid>
        </Grid>
      </Paper> */}
      <TableContainer component={Paper}>
        <Table aria-label="collapsible table">
          <TableHead>
            <TableRow>
              {/* <TableCell /> */}
              <TableCell>Name</TableCell>
              <TableCell align="center">Synonum</TableCell>
              <TableCell align="center">Type</TableCell>
              <TableCell align="center">Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paramTypes?.map((row) => (
              <Row key={row.FL_PNAME} row={row} handleSynonumParams={handleSynonumParams} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
AllParametersTab.Modulename = 'synonymsmaster'
export default AllParametersTab;
